// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const MeditateOutline = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M48.003 25.037c-12.664 0-22.966 10.303-22.966 22.967 0 12.66 10.302 22.959 22.966 22.959 12.66 0 22.96-10.299 22.96-22.959 0-12.664-10.3-22.967-22.96-22.967m0 49.926c-14.869 0-26.966-12.094-26.966-26.959 0-14.869 12.097-26.967 26.966-26.967 14.866 0 26.96 12.098 26.96 26.967 0 14.865-12.094 26.959-26.96 26.959m.001-62.463C28.427 12.5 12.5 28.428 12.5 48.007 12.5 67.578 28.427 83.5 48.004 83.5 67.577 83.5 83.5 67.578 83.5 48.007 83.5 28.428 67.577 12.5 48.004 12.5m0 75C26.222 87.5 8.5 69.783 8.5 48.007 8.5 26.223 26.222 8.5 48.004 8.5 69.782 8.5 87.5 26.223 87.5 48.007 87.5 69.783 69.782 87.5 48.004 87.5"
			fillRule="evenodd"
		/>
	</svg>
);
export default MeditateOutline;
